var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 4.99996V7.01662C18.3335 8.33329 17.5002 9.16663 16.1835 9.16663H13.3335V3.34162C13.3335 2.41662 14.0918 1.66663 15.0168 1.66663C15.9252 1.67496 16.7585 2.04162 17.3585 2.64162C17.9585 3.24996 18.3335 4.08329 18.3335 4.99996Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 5.83329V17.5C1.6665 18.1916 2.44984 18.5833 2.99984 18.1666L4.42484 17.1C4.75817 16.85 5.22483 16.8833 5.52483 17.1833L6.90817 18.575C7.23317 18.9 7.7665 18.9 8.0915 18.575L9.4915 17.175C9.78317 16.8833 10.2498 16.85 10.5748 17.1L11.9998 18.1666C12.5498 18.575 13.3332 18.1833 13.3332 17.5V3.33329C13.3332 2.41663 14.0832 1.66663 14.9998 1.66663H5.83317H4.99984C2.49984 1.66663 1.6665 3.15829 1.6665 4.99996V5.83329Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.43527L6.61826 9.05352L10.1 5.83337",
    stroke: "#2B2B2B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveInvoice);
export default __webpack_public_path__ + "static/media/save-invoice.922860511198461a057ab7becbbeadec.svg";
export { ForwardRef as ReactComponent };